import styled from "styled-components";

export const UserManagerWrapper = styled.div`
  padding: 24px;
  width: 100%;
  height: calc(100vh - 80px);
  display: flex;
  flex-direction: column;
  overflow: hidden;
`;

export const ToolbarRow = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 16px;
  flex-shrink: 0;
`;

export const TableContainer = styled.div`
  flex: 1;
  overflow-y: auto;
`;

export const LeftContainer = styled.div`
  width: 100%;
`;

export const RightContainer = styled.div`
  width: 35%;
`;

export const TitleManagerUser = styled.div`
  font-weight: bold;
  font-size: 32px;
  margin-top: 30px;
  margin-bottom: 20px;
`;

export const StatsRow = styled.div`
  display: flex;
  gap: 16px;
  margin-bottom: 24px;
  flex-wrap: wrap;
`;

export const StatCard = styled.div`
  background: white;
  padding: 20px;
  border-radius: 8px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
  min-width: 180px;
  flex: 1;
`;
